import { ChangeDetectionStrategy, Component } from '@angular/core';
import { version } from '@env/version';

/**
 * La versión del front (`v1.0.4`), en una esquina de todas las pantallas: así, si alguien reporta
 * un problema, se sabe si tiene la última versión. Sale de package.json, que cada MR sube.
 */
@Component({
  selector: 'app-version',
  template: `<span
    class="fixed bottom-0.5 right-1.5 z-[130] text-[10px] font-mono text-black/35 dark:text-white/35 pointer-events-none select-none"
    aria-hidden="true"
    >v{{ version }}</span
  >`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppVersionComponent {
  protected readonly version = version.version;
}
